/**
 * Get tomorrow's date (today + 1 day)
 * Useful for date pickers that need to disable the current date
 */
export function getTomorrowDate (): Date {
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return tomorrow
}
